import "./ConfigSection.css";
import BlockBadge from "../BlockBadge/BlockBadge";

function ConfigSection({ icon, label, accentColor, items }) {
    return (
        <div className="config-section">
            <div className="config-section-header">
                <i className={`fas ${icon}`} style={{ color: accentColor }}></i>
                <span className="config-section-label">{label}</span>
                {items.length > 1 ? <span className="config-section-count">{items.length}</span> : null}
            </div>
            {items.length > 0 ? (
                <div className="config-section-list">
                    {items.map((item, index) => {
                        const blocks = item.blocks || (item.block ? [item.block] : []);
                        return (
                            <div className="config-section-item" key={index}>
                                <div className="config-section-main">
                                    <span className="config-section-primary">{item.primary}</span>
                                    {item.secondary ? <span className="config-section-secondary">{item.secondary}</span> : null}
                                </div>
                                {blocks.length > 0 ? (
                                    <div className="config-section-blocks">
                                        {blocks.map((block, blockIndex) => (
                                            <BlockBadge key={blockIndex} name={block.name} color={block.color} href={block.href} />
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className="config-section-empty">No {label.toLowerCase()} configured for this bot.</p>
            )}
        </div>
    );
}

export default ConfigSection;
